import React, { useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import "./Measurement.css";

const SizeChart = () => {
  const [isCoOrdsOpen, setCoOrdsOpen] = useState(false);
  const [isDressOpen, setDressOpen] = useState(false);
  const [isSkirtOpen, setSkirtOpen] = useState(false);

  const toggleCoOrds = () => setCoOrdsOpen(!isCoOrdsOpen);
  const toggleDress = () => setDressOpen(!isDressOpen);
  const toggleSkirt = () => setSkirtOpen(!isSkirtOpen);

  return (
    <div className="size-chart-container">
      <h1>Size Chart</h1>

      {/* Co-ords Section */}
      <div className="chart-section">
        <button className="dropdown-button" onClick={toggleCoOrds}>
          <span>Co-ords Measurement</span>
          {isCoOrdsOpen ? (
            <FaChevronDown className="dropdown-icon rotate" />
          ) : (
            <FaChevronRight className="dropdown-icon" />
          )}
        </button>

        {isCoOrdsOpen && (
          <div className="dropdown-content">
            <h2>UK Size Chart for Co-ords (in Inches)</h2>
            <table>
              <thead>
                <tr>
                  <th>UK Size</th>
                  <th>Bust (in)</th>
                  <th>Waist (in)</th>
                  <th>Hips (in)</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>6</td><td>32</td><td>24</td><td>34</td></tr>
                <tr><td>8</td><td>34</td><td>26</td><td>36</td></tr>
                <tr><td>10</td><td>36</td><td>28</td><td>38</td></tr>
                <tr><td>12</td><td>38</td><td>30</td><td>40</td></tr>
                <tr><td>14</td><td>40</td><td>32</td><td>42</td></tr>
                <tr><td>16</td><td>42</td><td>34</td><td>44</td></tr>
                <tr><td>18</td><td>44</td><td>36</td><td>46</td></tr>
                <tr><td>20</td><td>46</td><td>38</td><td>48</td></tr>
                <tr><td>22</td><td>48</td><td>40</td><td>50</td></tr>
              </tbody>
            </table>
            <p>
              <strong>Bust:</strong> Measure around the fullest part of the bust.<br />
              <strong>Waist:</strong> Measure around the narrowest part of the waist.<br />
              <strong>Hips:</strong> Measure around the fullest part of the hips.
            </p>
          </div>
        )}
      </div>

      {/* Dress Section */}
      <div className="chart-section">
        <button className="dropdown-button" onClick={toggleDress}>
          <span>Dress Measurement</span>
          {isDressOpen ? (
            <FaChevronDown className="dropdown-icon rotate" />
          ) : (
            <FaChevronRight className="dropdown-icon" />
          )}
        </button>

        {isDressOpen && (
          <div className="dropdown-content">
            <h2>Dress Measurement</h2>
            <table>
              <thead>
                <tr>
                  <th>Size</th>
                  <th>Bust (in)</th>
                  <th>Waist (in)</th>
                  <th>Hips (in)</th>
                  <th>Length (in)</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>6</td><td>32</td><td>26</td><td>36</td><td>55</td></tr>
                <tr><td>8</td><td>34</td><td>28</td><td>38</td><td>56</td></tr>
                <tr><td>10</td><td>36</td><td>30</td><td>40</td><td>57</td></tr>
                <tr><td>12</td><td>38</td><td>32</td><td>42</td><td>58</td></tr>
                <tr><td>14</td><td>40</td><td>34</td><td>44</td><td>59</td></tr>
                <tr><td>16</td><td>42</td><td>36</td><td>46</td><td>60</td></tr>
                <tr><td>18</td><td>44</td><td>38</td><td>48</td><td>61</td></tr>
                <tr><td>20</td><td>46</td><td>40</td><td>50</td><td>62</td></tr>
              </tbody>
            </table>
            <p>
              <strong>Bust:</strong> Measure around the fullest part of the chest.<br />
              <strong>Waist:</strong> Measure around the smallest part of the waist.<br />
              <strong>Hips:</strong> Measure around the widest part of the hips.<br />
              <strong>Length:</strong> Measure from the top of the shoulder to the hemline.
            </p>
          </div>
        )}
      </div>

      {/* Skirt Section */}
      <div className="chart-section">
        <button className="dropdown-button" onClick={toggleSkirt}>
          <span>Skirt Measurement</span>
          {isSkirtOpen ? (
            <FaChevronDown className="dropdown-icon rotate" />
          ) : (
            <FaChevronRight className="dropdown-icon" />
          )}
        </button>

        {isSkirtOpen && (
          <div className="dropdown-content">
            <h2>Skirt Measurement</h2>
            <table>
              <thead>
                <tr>
                  <th>Size</th>
                  <th>Waist (in)</th>
                  <th>Hips (in)</th>
                  <th>Length (Short, Mid, Long) (in)</th>
                </tr>
              </thead>
              <tbody>
                {[6, 8, 10, 12, 14, 16, 18, 20, 22].map((size, index) => (
                  <tr key={index}>
                    <td>{size}</td>
                    <td>{26 + 2 * index}"</td>
                    <td>{36 + 2 * index}"</td>
                    <td>{`${18 + index}, ${24 + index}, ${42 + index}`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p>
              <strong>Waist:</strong> Measure around the smallest part of the waist.<br />
              <strong>Hips:</strong> Measure around the widest part of the hips.<br />
              <strong>Length:</strong> Short (18–23 in), Mid (24–31 in), Long (42–50 in).
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SizeChart;
